<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Compensation & Benefits Main Menu" @click="$router.push('/compensation')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="compensation" pageId="compensation-benefits" color="white"></help-link>
                </v-toolbar>
            </v-card>
            <v-alert v-if="!loading&&cutoff_setting==null" :value="true" color="error" icon="error" outline style="margin:10px 0px 10px 0px;">
                Cutoff settings has not been setup yet. 
            </v-alert>
            <v-card class="elavation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search year" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold ">Select calendar year</span>
                </v-toolbar>
               <v-data-table
                    :headers="headers"
                    :items="fiscal_periods_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" title="Click to View/Edit" style="cursor:pointer;">
                            <td>{{props.item.fiscalYear}}</td>
                            <td>{{props.item.fiscalStartDate|moment('MMMM D, YYYY')}}</td>
                            <td>{{props.item.fiscalEndDate|moment('MMMM D, YYYY')}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.fiscalPeriodStatus)">{{commonfn.getStatusDescription(props.item.fiscalPeriodStatus)}}</b>
                            </td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.recordStatus)">{{commonfn.getStatusDescription(props.item.recordStatus)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </v-layout> 
</template>

<script>

import allocationApi from '@/api/allocation'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'Annualization',
    metaInfo: {
        title: 'Annualization',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View/edit Annualization' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            snackbar: false,
            x: null,
            y: null,
            snackbarText: '',
            headers: [
                {text: 'Calendar Year',align: 'left',value: 'fiscalYear',width: '20%', sortable:true},
                {text: 'Start Date',align: 'left',value: 'fiscalStartDate',width: '20%', sortable:true},
                {text: 'End Date',align: 'left',value: 'fiscalEndDate',width: '20%', sortable:true},
                {text: 'Calendar Period Status',align: 'left',value: 'fiscalPeriodStatus',width: '20%', sortable:true},
                {text: 'Record Status',align: 'left',value: 'recordStatus',width: '20%', sortable:true},
            ],
            fiscal_periods: [],
            cutoff_setting: null
        }
    },
    methods: {
        viewDetails(data) {
            if (data.recordStatus != commonfn.getStatusCode('Approved')) {
                this.snackbarText = `Calendar period should be approved.`
                this.snackbar = true
            }else
                this.$router.push(`/compensation/allocation/${data.fiscalPeriodId}`)
        },
        async getAllocationMain() {
            try {
                this.loading = true
                const response = await allocationApi.getMain() 
                if (response && response.status==200) {
                    this.fiscal_periods = response.data.fiscalPeriods
                    this.cutoff_setting = response.data.cutOffSettings
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() {    
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Compensation & Benefits'
        })

        this.getAllocationMain()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        fiscal_periods_filtered() {
            var temp = this.fiscal_periods
            if (this.search) {
                temp = temp.filter(item => {
                    return (item.fiscalYear.toString().includes(this.search))
                })
            }
            return temp.reverse()
        }
    }
}
</script>